<div class="profile-container">
  <!-- User details -->
  <div class="first-part part">
    <div class="part-content-wrap">
      <div
        class="profile-pic c-pt"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasUserDetails"
        aria-controls="offcanvasRight"
        (click)="manageOffCanvasValues('profileUpdate')"
      >
        <img
          *ngIf="!userProfileUrl"
          src="../../../../assets/images/company-management/ic_userSample.svg"
        />
        <img *ngIf="userProfileUrl" [src]="userProfileUrl" />
      </div>
      <div class="ms-4 w-100">
        <div class="enter w-50">
          <label
            for="name"
            class="form-label required"
            [style.color]="isProfileEdit ? 'black' : '#8F9098'"
          >
            Name
          </label>
          <input
            type="text"
            placeholder="Enter company name"
            [(ngModel)]="userObjForName.fullName"
            *ngIf="isProfileEdit"
            id="companyName"
          />
          <h6 class="mb-0" *ngIf="!isProfileEdit">
            {{ userObjForName.fullName }}
          </h6>
        </div>
      </div>
    </div>
    <button class="btn edit-btn" (click)="manageEdits('profile Edit')" *ngIf="!isProfileEdit">
      <span>Edit</span>
      <img src="../../../../../../../assets/images/newediticon.svg" />
    </button>
    <div class="d-flex justify-content-center flex-nowrap" *ngIf="isProfileEdit">
      <button class="btn canc-btn edit-btn me-2" (click)="cancelEdit('profile Edit')">
        Cancel
      </button>
      <button
        class="btn save-btn edit-btn ms-2"
        (click)="editUserDetails(userObjForName, 'profile Edit')"
      >
        Save
      </button>
    </div>
  </div>

  <!-- User basic details grid -->
  <div class="container-wrapper">
    <div class="secnd-part part">
      <div class="part-content-wrap">
        <div class="enter me-3 d-flex justify-content-between">
          <div class="d-inline-block">
            <label for="name" class="form-label required" style="color: #8f9098"> Email </label>
            <h6 class="mb-0">
              {{ userObjForBasicDetails.email }}
            </h6>
          </div>
          <button
            class="btn edit-btn"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasUserDetails"
            aria-controls="offcanvasRight"
            (click)="manageOffCanvasValues('emailUpdate')"
          >
            <span>Edit</span>
            <img src="../../../../../../../assets/images/newediticon.svg" />
          </button>
        </div>
        <div class="enter ms-3" style="width: 70%">
          <label
            for="name"
            class="form-label"
            [style.color]="isBasicDetailsEdit ? 'black' : '#8F9098'"
          >
            Phone
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter phone number"
            [(ngModel)]="userObjForBasicDetails.phoneNumber"
            *ngIf="isBasicDetailsEdit"
            id="phone"
          />
          <h6 class="mb-0" *ngIf="!isBasicDetailsEdit">
            {{ userObjForBasicDetails.phoneNumber ?? '-' }}
          </h6>
        </div>
      </div>
      <button
        class="btn edit-btn"
        (click)="manageEdits('basicDetails Edit')"
        *ngIf="!isBasicDetailsEdit"
      >
        <span>Edit</span>
        <img src="../../../../../../../assets/images/newediticon.svg" />
      </button>
      <div class="d-flex justify-content-center flex-nowrap" *ngIf="isBasicDetailsEdit">
        <button class="btn canc-btn edit-btn me-2" (click)="cancelEdit('basicDetails Edit')">
          Cancel
        </button>
        <button
          class="btn save-btn edit-btn ms-2"
          (click)="editUserDetails(userObjForBasicDetails, 'basicDetails Edit')"
        >
          Save
        </button>
      </div>
    </div>
  </div>

  <!-- User change password field -->
  <div class="third-part part" style="padding-block: 16px">
    <div style="width: 90%">
      <h6 class="mb-2">Password</h6>
      <div class="row w-100">
        <div class="col-12">
          <div class="enter w-50">
            <label for="name" class="form-label pb-0" style="color: #8f9098">
              Manage password
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center flex-nowrap">
      <button
        class="btn"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasUserDetails"
        aria-controls="offcanvasRight"
        (click)="manageOffCanvasValues('passwordUpdate')"
      >
        <img width="22" src="../../../../assets/images/mingcute_right-fill.svg" />
      </button>
    </div>
  </div>
</div>

<!-- Htmnl for updating user profile pic content -->
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvasUserDetails"
  aria-labelledby="offcanvasRightLabel"
  data-bs-backdrop="static"
>
  <div class="offcanvas-header p-0">
    <div class="d-flex flex-column justify-content-center">
      <h5
        class="mb-0 offcanvas-title"
        id="offcanvasRightLabel"
        style="color: #424242; font-weight: 600"
      >
        {{
          offCanvasVal === 'profileUpdate'
            ? 'Edit Profile Photo'
            : offCanvasVal === 'emailUpdate'
              ? 'Edit Email'
              : 'Change Password'
        }}
      </h5>
    </div>
    <button
      type="button"
      class="btn-close"
      #closeCanvas
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <div class="offcanvas-body p-0">
    <!-- Profile Grid -->
    <div class="d-flex justify-content-center pt-3" *ngIf="offCanvasVal === 'profileUpdate'">
      <div class="profile-pic c-pt" *ngIf="previewUrl">
        <img [src]="previewUrl" />
      </div>
      <div class="import-logo c-pt" *ngIf="!previewUrl">
        <img src="../../../assets/images/company-management/companyLogo_import.svg" />
      </div>
      <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" hidden />
    </div>
    <!-- Email Grid -->
    <div class="pt-3" *ngIf="offCanvasVal === 'emailUpdate'">
      <div class="w-100" *ngIf="tabIndx == 1">
        <div class="enter w-100">
          <label for="name" class="form-label text-black"> Email </label>
          <input type="text" placeholder="Enter email" [(ngModel)]="emailToUpdate" id="emailId" />
        </div>
      </div>
      <div class="w-100" *ngIf="tabIndx == 2">
        <p style="color: #6d6d6d">
          We have sent the code to the email address below. Verify your account by typing 6 digit
          code.
        </p>
        <div class="emial-validate-grid">
          <div class="d-flex align-items-center justify-content-between">
            <p style="color: #0070b9">{{ emailToUpdate }}</p>
            <p class="c-pt" style="color: #0070b9; font-weight: 500" (click)="chnageTabIndx('pre')">
              Edit
            </p>
          </div>
          <div class="mt-4">
            <ng-otp-input
              (onInputChange)="onOtpChange($event)"
              [config]="{ length: 6 }"
            ></ng-otp-input>
          </div>
          <p class="mt-4 text-black" style="font-weight: 500">
            Resend Code in
            <span style="color: #0070b9">
              {{ otpTimer > 0 ? +otpTimer + ' seconds' : '' }}
            </span>
          </p>
          <button class="btn mt-4 px-0" style="color: #0070b9; font-weight: 500">Resend</button>
        </div>
      </div>
    </div>
    <!-- Password Grid -->
    <div class="pt-3" *ngIf="offCanvasVal === 'passwordUpdate'">
      <div class="w-100 mb-3">
        <label for="name" class="form-label text-black required"> Old Password </label>

        <div class="input-wrapper">
          <img src="../../../../assets/images/ic-password.svg" />
          <input
            type="text"
            class="form-control form-input"
            autocomplete="new-password"
            name="oldPass"
            (keyup)="getBtnStatus()"
            [(ngModel)]="changePasswordObj.oldPassword"
            [type]="showOldPass ? 'text' : 'password'"
            placeholder="Enter old password"
          />
          <button
            class="btn p-0 border-0"
            (click)="toggleOldPass()"
            [disabled]="!changePasswordObj.oldPassword"
          >
            <img
              class="c-pt"
              [src]="
                showOldPass
                  ? '../../../../assets/images/ic-pass_show.svg'
                  : '../../../../assets/images/ic-pass_hide.svg'
              "
            />
          </button>
        </div>
      </div>
      <div class="w-100 mb-3">
        <label for="name" class="form-label text-black required"> New Password </label>
        <div class="input-wrapper">
          <img src="../../../../assets/images/ic-password.svg" />
          <input
            type="text"
            class="form-control form-input"
            autocomplete="new-password"
            name="newPass"
            (keyup)="getBtnStatus()"
            [(ngModel)]="changePasswordObj.newPassword"
            [type]="showNewPass ? 'text' : 'password'"
            placeholder="Enter new password"
          />
          <button
            class="btn p-0 border-0"
            (click)="toggleNewPass()"
            [disabled]="!changePasswordObj.newPassword"
          >
            <img
              class="c-pt"
              [src]="
                showNewPass
                  ? '../../../../assets/images/ic-pass_show.svg'
                  : '../../../../assets/images/ic-pass_hide.svg'
              "
            />
          </button>
        </div>
      </div>
      <div class="w-100">
        <label for="name" class="form-label text-black required"> Confirm Password </label>

        <div class="input-wrapper">
          <img src="../../../../assets/images/ic-password.svg" />
          <input
            type="text"
            class="form-control form-input"
            autocomplete="new-password"
            name="confirmPass"
            (keyup)="getBtnStatus()"
            [(ngModel)]="changePasswordObj.conformPassVal"
            [type]="togglecpass ? 'text' : 'password'"
            placeholder="Confirm new password"
          />
          <button
            class="btn p-0 border-0"
            (click)="toggleCPasswordVisibility()"
            [disabled]="!changePasswordObj.conformPassVal"
          >
            <img
              class="c-pt"
              [src]="
                togglecpass
                  ? '../../../../assets/images/ic-pass_show.svg'
                  : '../../../../assets/images/ic-pass_hide.svg'
              "
            />
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="offcanvas-footer">
    <!-- User profile buttons -->
    <div class="w-100" *ngIf="offCanvasVal === 'profileUpdate'">
      <button
        class="btn"
        *ngIf="!previewUrl"
        (click)="selectProfile()"
        style="background-color: #f0f8ff; color: #0070b9"
      >
        Add profile photo
      </button>
      <button
        class="btn text-white"
        *ngIf="previewUrl && isNewProfile"
        style="background-color: #0070b9"
        (click)="updateUserProfile()"
      >
        Update
      </button>
      <button
        class="btn"
        (click)="removeImage()"
        *ngIf="previewUrl && !isNewProfile"
        style="background-color: #ffebee; color: #ef5350"
      >
        Remove
      </button>
    </div>
    <!-- User email update buttons -->
    <div class="w-100" *ngIf="offCanvasVal === 'emailUpdate'">
      <button
        class="btn text-white"
        [disabled]="
          (!emailToUpdate.includes('.com') && tabIndx == 1) || (tabIndx == 2 && !isEmailVarified)
        "
        (click)="chnageTabIndx('next')"
        style="background-color: #0070b9"
      >
        {{ tabIndx == 1 ? 'Update' : 'Confirm' }}
      </button>
    </div>
    <!-- User password update buttons -->
    <div class="w-100" *ngIf="offCanvasVal === 'passwordUpdate'">
      <button
        class="btn text-white"
        style="background-color: #0070b9"
        (click)="chnageUserPassword()"
        [disabled]="
          !(
            isAbleToSet &&
            changePasswordObj.conformPassVal &&
            changePasswordObj.newPassword == changePasswordObj.conformPassVal
          )
        "
      >
        Update Password
        <i class="fa ms-2" [ngClass]="{ 'fa-spin fa-spinner': isLoading }"></i>
      </button>
    </div>
  </div>
</div>
